export default "/WebApp/dist/assets/svg/sal_default_icon.svg";